$(document).ready(function() {

// ----------Testimonial js--------
  new Swiper('.Testimonial-swiper-container', {
        loop: false,
       navigation: {
          nextEl: '.testimonial_icon-prev ',
          prevEl: '.testimonial_icon-next',
        },
       
        slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            780: {
                slidesPerView: 2,
                spaceBetween: 20
            },
           580: {
                slidesPerView: 1
            }
        }
    });
 if ($(window).width() <= 767) {
   new Swiper(".custom_carousel", {
       loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
          nextEl: '.instagram_icon-next',
          prevEl: '.instagram_icon-prev',
        }
   });
 }
if ($(window).width() >= 767) {
var swiper_marquee = new Swiper(".custom-marquee-main", {
       loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      spaceBetween: 0,
      loop: true,
      effect: 'slide',
      longSwipes: true,
      autoHeight: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      autoplayDisableOnInteraction:true,
      navigation: {
          nextEl: '.marquee_icon-prev ',
          prevEl: '.marquee_icon-next',
        }
});
}
  
var swiper = new Swiper(".custom_product-grid-slider", {
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
          nextEl: '.swiper-button-next-icon',
          prevEl: '.swiper-button-prev-icon',
        },
      
      breakpoints: {
            1920: {
                slidesPerView: 6,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            780: {
                slidesPerView: 2,
                spaceBetween: 20
            },
           580: {
                slidesPerView: 2,
               spaceBetween: 10
            }
        }
 });


// product media slider js
// Swiper: Slider
    new Swiper('.cst-product-swiper-container', {
        loop: true,
        autoHeight: true,
        navigation: {
          nextEl: '.cst-swiper-pdct-next-icon',
          prevEl: '.cst-swiper-pdct-prev-icon',
        },
        slidesPerView: 1,
        paginationClickable: true,
        breakpoints: {
            1920: {
                slidesPerView: 1
            },
            1028: {
                slidesPerView: 1
            },
            480: {
                slidesPerView: 1
            }
        }
    });


  // Show the first tab and hide the rest
    $('ul.shop_by_category li:first-child').addClass('active');
    $('.collection_list_menu').hide();
    $('.header ul.list-menu li').each(function () {
      $(this).find('.collection_list_menu:first').show();
    });
  
  $('ul.shop_by_category li').click(function(event){
    event.preventDefault(); // Prevent the default action of the <a> tag
    
    // Remove 'active' class from all li elements
    $(this).closest('.cst-mega-menu-Images').find('ul.shop_by_category li').removeClass('active');
    
    // Add 'active' class to the clicked li element
    $(this).closest('li').addClass('active');
    
    // Hide all collection lists
    $(this).closest('.cst-mega-menu-Images').find('.collection_list_menu').hide();
    
    // Show the collection list corresponding to the clicked tab
    var activeTab = $(this).attr('data_id');
    $(this).closest('.cst-mega-menu-Images').find(activeTab).fadeIn();
    
    return false;
  });


setTimeout(function() {
     var selling_plan = $('.appstle_sub_widget').attr("data-selected-selling-plan");
   
   if (selling_plan && selling_plan.length) {
           $('.custom_popup_box').show();
           $('body.template_box-product-subscriptions').addClass('popup_overlay');

           $(".product_subscriptions.first .radio_button_box:first-child input").attr('checked', true);
           $(".product_subscriptions.first_product_1 .radio_button_box:first-child input").attr('checked', true);
           $(".collection_list_box .variant_items .collection_list_product:first-child input").attr('checked', true);
        
           var data_product = $('.product_subscriptions.first .radio_button_box:first-child input').val();
           $('input.first_line_itme').val(data_product);

          var data_product = $('.product_subscriptions.first_product_1 .radio_button_box:first-child input').val();
          $('input.itme_subscription_ball').val(data_product);
   
          var data_collection = $('.collection_list_box .variant_items .collection_list_product:first-child input').val();
          $('input.collection_line_itme').val(data_collection);
     
      }else{
         $('body.template_box-product-subscriptions').removeClass('popup_overlay');
         $('.custom_popup_box').hide();
         $('input.first_line_itme').val("");
         $('input.collection_line_itme').val("");
      }
  
   }, 1000);
  
$(document).on('click','.appstle_subscription_wrapper_option.appstle_include_dropdown input#appstle_selling_plan_label_20 ', function(e){
     $('.custom_popup_box').show();
      $('body.template_box-product-subscriptions').addClass('popup_overlay');
     $(".product_subscriptions.first .radio_button_box:first-child input").attr('checked', true);
     $(".product_subscriptions.first_product_1 .radio_button_box:first-child input").attr('checked', true);
     $(".collection_list_box .variant_items .collection_list_product:first-child input").attr('checked', true);
      setTimeout(function() {
         $('.template_box-product-half-yearly-subscription .appstle_subscribe_save_text').text('Claim your free paddle now!');
      }, 1000);
  
      var data_product = $('.product_subscriptions.first .radio_button_box:first-child input').val();
      $('input.first_line_itme').val(data_product);

       var data_product = $('.product_subscriptions.first_product_1 .radio_button_box:first-child input').val();
       $('input.itme_subscription_ball').val(data_product);
   
       var data_collection = $('.collection_list_box .variant_items .collection_list_product:first-child input').val();
       $('input.collection_line_itme').val(data_collection);
});  

$(document).on('click','.appstle_subscription_wrapper_option input#appstle_selling_plan_label_10', function(e){
    $('.custom_popup_box').hide();
    $('input.first_line_itme').val("");
    $('input.collection_line_itme').val("");
});  

$(document).on("click", ".product_subscriptions.first .radio_button_box input[type = 'radio']:checked", function() {
  var dataID = $(this).val();
   $('input.first_line_itme').val(dataID);
   $('.variant_product-value_1').attr('data-value', dataID);
}); 

$(document).on("click", ".product_subscriptions.first_product_1 .radio_button_box input[type = 'radio']:checked", function() {
  var dataID = $(this).val();
   $('input.itme_subscription_ball').val(dataID);
   $('.variant_product-value_2').attr('data-value', dataID);
}); 

$(document).on("click", ".collection_list_product input[type = 'radio']:checked", function() {
  var dataTilte = $(this).val();
  $('input.collection_line_itme').val(dataTilte);
  $('.variant_product-value_3').attr('data-value', dataTilte);
}); 

$("input.custom_Product_puls_subscribe ,.itg_options.Product_subscribe_options label.itg_options_label").on('click', function(){  

   $('.custom_subscribe-popup').show();
   $('body').addClass('popup_overlay');
   $(".product_subscriptions.first .radio_button_box:first-child input").attr('checked', true);
   $(".product_subscriptions.first_product_1 .radio_button_box:first-child input").attr('checked', true);
   $(".collection_list_box .variant_items .collection_list_product:first-child input").attr('checked', true);

  
  var data_product_1 = $('.product_subscriptions.first .radio_button_box:first-child input').val();
  $('.variant_product-value_1').attr('data-value', data_product_1);

   var data_product_2 = $('.product_subscriptions.first_product_1 .radio_button_box:first-child input').val();
  $('.variant_product-value_2').attr('data-value', data_product_2);

   var data_collection_3 = $('.collection_list_box .variant_items .collection_list_product:first-child input').val();
   $('.variant_product-value_3').attr('data-value', data_collection_3);

});
  
$(".custom_close_icon.close_icon").on('click', function(){    
    $('.custom_subscribe-popup').hide();
    $('body').removeClass('popup_overlay');
});

//-------- addon_product add to cart js-------
$(document).on('click', '.product_add_to-cart_button', function(e) {
    e.preventDefault();
    Shopify.queue = [];
    var findsel_val = $('.product-variant-id').attr('value');
    var quantity_val = $('.product__info-wrapper').find("input.quantity-selector__input").val();
    
    Shopify.queue.push({
        variantId: findsel_val,
        qty: quantity_val
    });
    
    $('.Subscription_Product_box').each(function() {
        var varid = $(this).attr('data_id');
        var quantity_val = 1;
        var sellingId = $(this).parents('.product__info-wrapper').find('.custom_add_to_cart_box').find('#subscribe_select option:selected').attr('value');
        
        var properties_1 = $('.variant_product-value_1').attr('data-value');
        var properties_2 = $('.variant_product-value_2').attr('data-value');
        var properties_3 = $('.variant_product-value_3').attr('data-value');
      
        // Define custom line item properties
          var customProperties = {
            "Water Bottle": properties_1,
            "Pickleball": properties_2,
           "Subscription Paddles": properties_3
          };
        if (varid != '') {
            Shopify.queue.push({
                variantId: varid,
                qty: quantity_val,
                selling_plan: sellingId,
               properties: customProperties
            });
        }
    }).promise().done(function() {
        if (Shopify.queue.length > 0) {
            Shopify.moveAlong = function() {
                if (Shopify.queue.length) {
                    var request = Shopify.queue.shift();
                    var varid = request.variantId;
                    var qty_box = request.qty;
                    var data = {
                        id: varid,
                        quantity: qty_box
                    };
                    if (request.selling_plan) {
                        data.selling_plan = request.selling_plan;
                    }
                    if (request.properties) {
                        data.properties = request.properties; // Include properties in the data object
                    }
                    $.ajax({
                        method: 'POST',
                        url: '/cart/add.js',
                        data: data,
                        dataType: 'json',
                        success: function(res) {
                            Shopify.moveAlong();
                        },
                        error: function(data) {
                            Shopify.moveAlong();
                        }
                    });
                } else {
                    window.location.href = '/cart';
                }
            }
            Shopify.moveAlong();
        } else {
            return false;
        }
    });
});

$(".itg_options.itg_options_subscribe input").on('click', function(){
    window.location.href = "/products/subscription";
});

$(document).on("click", ".subscription-product_name input[type=radio]:checked", function() {
   var checked_value = $(this).val();
   if (checked_value === "EXPLORE 16mm All Court Paddle Premium Set - 4 Colors") {
       var first_checked_value = $('.subscriptio_form__label fieldset.product-form__input.product-form__input--pill input[type=radio]:checked').val();
       $('.half_yearly-line_item_property').val(first_checked_value);
       $('.subscriptio_form__label').show();
    } else {
        $('.subscriptio_form__label').hide();
        $('.half_yearly-line_item_property').val("");
    }
});

$(document).on("click", ".subscriptio_form__label fieldset.product-form__input.product-form__input--pill input[type=radio]:checked", function() {
    var Color_value = $(this).val();
  $('.half_yearly-line_item_property').val(Color_value);
});
    
var checked_value = $('.subscription-product_name input[type=radio]:checked').val();
 
if (checked_value === "EXPLORE 16mm All Court Paddle Premium Set - 4 Colors") {
  var first_child_value = $('.subscriptio_form__label fieldset.product-form__input.product-form__input--pill:first-child input[type=radio]:checked').val();
    $('.subscriptio_form__label').show();
    $('.half_yearly-line_item_property').val(first_child_value);
} else {
    $('.subscriptio_form__label').hide();
    $('.half_yearly-line_item_property').val("");
}
setTimeout(function() {
   $('.template_box-product-half-yearly-subscription .appstle_subscribe_save_text').text('Claim your free paddle now!');
}, 800);

  
// $(document).on("click", ".subscription-product_name input[type=radio]:checked", function() {

//       // Iterate over elements and apply/remove the disabled class
//         $('.subscription-product-color input').each(function() {
//             if ($(this).hasClass('disabled')) {
//                 $(this).prop('checked', false);
//             } else {
//                 $(this).prop('checked', true);
//             }
//         });
  
//   setTimeout(function() {
//     var firstNonDisabled = $('.subscription-product-color input').not('.disabled').first();
//     if (firstNonDisabled.length) {
//       firstNonDisabled.prop('checked', true).addClass('active');
//       // Trigger change event to ensure UI updates
//         firstNonDisabled.trigger('change'); // Trigger change event

//         // Optionally trigger a click event to simulate user interaction
//         firstNonDisabled.trigger('click');
//        firstNonDisabled.attr("checked", "checked");
//     }
//   // $(".product__info-container variant-selects").load(window.location.href + " .product__info-container variant-selects");
//    }, 1000);
// });

  
$(document).on("click", ".option_tmp_select .facet-filters__label_product", function() {
    $(this).closest(".option_tmp_select").children('#custom_SortBy').toggle();
});
$(document).on("click", "ul#custom_SortBy li", function() {
     var aux = $(this).text();    
});

document.querySelectorAll(".header__inline-menu details").forEach((item) => {
    // Add mouseover event listener
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", ""); // Set the open attribute to make it visible
    });

    // Add mouseleave event listener to remove the open attribute
    item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
    });

    // Add mouseleave event listener to the <ul> inside the details element
    const ulElement = item.querySelector("ul");
    if (ulElement) {
        ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
    }
});

  
// $('.product-info-newlyCk').each(function() {
//       var publishedAt = $(this).data('published-at');
//       var publishedDate = new Date(publishedAt);
//       var currentTime = new Date();
//       var timeDifference = (currentTime - publishedDate) / 1000;
  
//     // var time = 2 *24*60*60;
    
//       if ($('.product-info-newlyCk').hasClass('custmr_newone_show')) {
//         $(this).show();
//       } else if ($('.product-info-newlyCk').hasClass('custmr_newone_hide')) {
//         if (timeDifference > 172800) { 
//           $(this).show();
//         } else {
//           $(this).hide();
//         }
//       } else {
//         $(this).show();
//       }
//   });

  

  
});  






